<template>
  <div class="about-us">
    <div class="robot-img">
      <img src="../../assets/images/aboutUs/robot.png">
    </div>
    <div class="about-us-text">智能聊天机器人</div>
    <div class="footer" style="font-size: 10px;color: #ccc">版本1.0</div>
  </div>
</template>

<script>
  export default {
    name: 'AboutUs'
  }
</script>

<style scoped lang="less">
  .about-us{
    padding: 0 15px;
    font-size: 14px;
    text-align: center;
    .robot-img{
      margin-bottom: 20px;
      margin-top: 40px;
      img{
        width: 80px;
      }
    }
    .about-us-text{
      margin-bottom: 10px;
    }
  }
</style>
